import {
  Divider,
  Flex,
  // Heading,
  Item,
  SearchField,
  View,
  DialogContainer,
  ActionButton,
  Picker,
  Link as V3Link,
  Text,
  Header,
  TooltipTrigger,
  Tooltip,
} from "@adobe/react-spectrum";
import Workflow from "@spectrum-icons/workflow/Workflow";
import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { error } from "@react/react-spectrum/Toast";
import Edit from "@spectrum-icons/workflow/Edit";
import CamSlidingPane from "../../components/Common/CamSlidingPane/CamSlidingPane";
import AccountRelDialog from "../../components/Dialog/AccountRelDialog";
import Table from "../../components/Common/Table";
import AccountMappingForm from "../../components/Forms/AccountMappingForm/AccountMappingForm";
import {
  AccountRelationshipColumn,
  SourceSystemAccountsColumn,
  StandardizedAccountsColumn,
  OrgEntityAccountsColumn,
  OrgEntitySourceSystemAccountsColumn,
} from "../../constants/Columns";
import {
  SourceSystemAccountsLabel,
  StandardizedAccountsLabel,
  OrgEntityAccountsLabel,
} from "../../constants/SlidingPaneLabels";
import { ManageAccountMappingPath } from "../../constants/Routes";
import "./account-mapping.css";
import LoadingDialog from "../../components/Dialog/LoadingDialog";
import { crossSystemAccountApi } from "../../api/lookupApi";
import useValidUserAccess from "../../hooks/useValidUserAccess";
import { ADMIN, SUPERUSER, OPERATOR, USER } from "../../constants/RoleType";
import { HMS } from "../../constants/CamFunctions";
// import useUserProfile from "../../context/user-context";

export default function AccountMapping() {
  const LOOKUP_REQUEST = {};
  const standardizedAccountsColumn = StandardizedAccountsColumn();
  const sourceSystemAccountsColumn = SourceSystemAccountsColumn();
  const accountRelationshipColumn = AccountRelationshipColumn();
  const orgEntityAccountsColumn = [
    ...OrgEntityAccountsColumn(),
    {
      name: "Manage",
      uid: "manage",
      defaultWidth: 100,
    },
  ];
  const orgEntitySourceSystemAccountsColumn =
    OrgEntitySourceSystemAccountsColumn();
  const [options, setOptions] = useState([
    {
      id: "camid",
      name: "CAM Id",
    },
    {
      id: "accountid",
      name: "Source System Account Id",
    },
  ]);
  const [lookupAccounts, setLookupAccounts] = useState([]);
  const [standardisedAccounts, setStandardisedAccounts] = useState();
  const [sourceSystemAccounts, setSourceSystemAccounts] = useState([]);
  const [sourceSystemAccountMap, setSourceSystemAccountMap] = useState({});
  const [camId, setCamId] = useState("");
  const [sourceSystemAccountId, setSourceSystemAccountId] = useState("");
  const [orgId, setOrgId] = useState("");
  const { authState } = useOktaAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const [slidingPaneData, setSlidingPaneData] = useState({});
  const [slidingPaneLabels, setSlidingPaneLabels] = useState([]);
  const [camidSelected, setCamidSelected] = useState("");
  const [accountRelData, setAccountRelData] = useState([]);
  const [typeOfDialog, setTypeOfDialog] = useState();
  const [filters, setFilters] = useState({ typeOfAccount: "camid", id: "" });
  const [isORGLookup, setIsORGLookup] = useState(false);
  const [isPageLoading, setPageLoading] = useState(false);
  const history = useHistory();
  // const { user } = useUserProfile();
  // todo: update based on rbac controls
  const isHMSActionAllowed = useValidUserAccess(
    [ADMIN, SUPERUSER, OPERATOR, USER],
    HMS
  );

  useEffect(() => {
    if (filters.typeOfAccount === "accountid") {
      setSourceSystemAccountId(filters.id);
    }
    if (filters.typeOfAccount === "camid") {
      setCamId(filters.id);
    }
    if (filters.typeOfAccount === "orgid") {
      setOrgId(filters.id);
    }
  }, [filters]);

  useEffect(() => {
    if (history?.location?.state?.searchFilter) {
      setFilters(history?.location?.state?.searchFilter);
    }
    // allow users with hms control to search by org id
    if (isHMSActionAllowed)
      setOptions([
        ...options,
        {
          id: "orgid",
          name: "ORG Id",
        },
      ]);
  }, [isHMSActionAllowed]);

  const createStandardizedAccount = (account, index) => {
    const standardizedAccount = account;
    standardizedAccount.address_key = `${
      account.street ? account.street : ""
    } ${account.street_sup ? account.street_sup : ""} ${
      account.city ? account.city : ""
    }, ${account.state ? account.state : ""} ${
      account.country ? account.country : ""
    } ${account.postalcode ? account.postalcode : ""}`;
    const createdDate = new Date(account.createddatetime);
    standardizedAccount.sliding_created_at = `${createdDate.toUTCString()} by ${
      account.createdby
    }`;
    const modifiedDate = new Date(account.modifieddatetime);
    standardizedAccount.sliding_last_updated = `${modifiedDate.toUTCString()} by ${
      account.modifiedby
    }`;
    standardizedAccount.index = index;

    if (index === 0) setCamidSelected(standardizedAccount.camid);
    return standardizedAccount;
  };

  const createSourceSystem = (sourceSystemList) => {
    sourceSystemList.forEach((account, index) => {
      const sourceSystemAccount = account;
      sourceSystemAccount.index = index;
      // const createdDate = new Date(account.createddatetime);
      // const modifiedDate = new Date(account.modifieddatetime);
      // sourceSystemAccount.sliding_created_at = `${createdDate.toUTCString()} by ${
      //   account.createdby
      // }`;
      // sourceSystemAccount.sliding_last_updated = `${modifiedDate.toUTCString()} by ${
      //   account.modifiedby
      // }`;
      const address = account.address[0];
      sourceSystemAccount.address_key = `${
        address.street ? address.street : ""
      } ${address.street_sup ? address.street_sup : ""} ${
        address.city ? address.city : ""
      }, ${address.state ? address.state : ""} ${
        address.country ? address.country : ""
      } ${address.postalcode ? address.postalcode : ""}`;
      sourceSystemAccount.street = address.street ? address.street : "";
      sourceSystemAccount.street_sup = address.street_sup
        ? address.street_sup
        : "";
      sourceSystemAccount.city = address.city ? address.city : "";
      sourceSystemAccount.state = address.state ? address.state : "";
      sourceSystemAccount.postalcode = address.postalcode
        ? address.postalcode
        : "";
      sourceSystemAccount.country = address.country ? address.country : "";
      sourceSystemAccount.id = account.source_system.concat(
        ":",
        account.account_id
      );
    });
    return sourceSystemList;
  };

  useEffect(() => {
    if (
      lookupAccounts.length > 0 &&
      !lookupAccounts[0].message &&
      lookupAccounts[0]?.org_entity_account === null
    ) {
      const stdAccounts = [];

      lookupAccounts.forEach((accounts, index) => {
        const standardizedAccount = accounts.standardized_account;
        const stdData = createStandardizedAccount(standardizedAccount, index);
        stdAccounts.push(stdData);

        const sourceSystemList = accounts.source_system_account_list;
        if (sourceSystemList) {
          const srcActList = createSourceSystem(sourceSystemList);
          sourceSystemAccountMap[stdData.camid] = srcActList;
          setSourceSystemAccountMap(sourceSystemAccountMap);
          if (index === 0) {
            setSourceSystemAccounts(srcActList);
          }
        }
      });

      setStandardisedAccounts(stdAccounts);
    } else if (
      lookupAccounts.length > 0 &&
      !lookupAccounts[0].message &&
      lookupAccounts[0]?.org_entity_account !== null
    ) {
      // todo update once duns id data issue fixed
      setStandardisedAccounts([
        createStandardizedAccount(lookupAccounts[0].org_entity_account, 0),
      ]);
      setSourceSystemAccounts(
        createSourceSystem(lookupAccounts[0].source_system_account_list)
      );
      setCamidSelected(lookupAccounts[0].org_entity_account.org_entity_id);
    }
  }, [lookupAccounts]);

  const clearStandardisedAndSourceAccounts = () => {
    setStandardisedAccounts([]);
    setSourceSystemAccounts([]);
  };

  const handleSourceAccountChange = (camid) => {
    setCamidSelected(camid);
    const sourceSystemList = sourceSystemAccountMap[camid];
    const srcActList = createSourceSystem(sourceSystemList);
    setSourceSystemAccounts(srcActList);
  };

  const handleError = (e) => {
    if (e.toString().toLowerCase().includes("network"))
      error(`Server not reachable! Please contact CAM team!`, {
        timeout: 5000,
      });
    else if (e?.response?.data) {
      error(e?.response?.data?.message, {
        timeout: 5000,
      });
    } else {
      error(`Sorry something went wrong! Please contact CAM team!`, {
        timeout: 5000,
      });
    }
  };

  const changeSuccessState = (data) => {
    const msg = data[0].message;
    if (msg && msg !== "" && msg.trim() !== "") {
      clearStandardisedAndSourceAccounts();
      setLookupAccounts([]);
    } else {
      clearStandardisedAndSourceAccounts();
      setLookupAccounts([...data]);
    }
  };

  const getData = () => {
    setPageLoading(true);
    if (filters.typeOfAccount === "camid") {
      LOOKUP_REQUEST.camid = camId;
      setIsORGLookup(false);
    } else if (filters.typeOfAccount === "accountid") {
      LOOKUP_REQUEST.account_id = sourceSystemAccountId;
      setIsORGLookup(false);
    } else if (filters.typeOfAccount === "orgid") {
      LOOKUP_REQUEST.org_entity_id = orgId;
      setIsORGLookup(true);
    }

    if (Object.keys(LOOKUP_REQUEST).length > 0) {
      crossSystemAccountApi
        .fetchAccountMappings(LOOKUP_REQUEST, authState.accessToken)
        .then((data) => {
          changeSuccessState(data);
          setPageLoading(false);
        })
        .catch((e) => {
          handleError(e);
          setPageLoading(false);
        });
    }
  };

  const handleOpenDialog = (data, accountType) => {
    let label = [];
    if (accountType === "standardized") {
      label = StandardizedAccountsLabel();
    } else if (accountType === "org") {
      label = OrgEntityAccountsLabel();
    } else {
      label = SourceSystemAccountsLabel(data);
    }

    setSlidingPaneData(data);
    setSlidingPaneLabels(label);
    setOpenDialog(!openDialog);
  };

  const handleManageStandardizedAccount = () => {
    history.push(ManageAccountMappingPath, {
      orgEntityAccInfo: standardisedAccounts,
      sourceSystemAccInfo: sourceSystemAccounts,
      searchFilter: filters,
      dunsId: standardisedAccounts[0].duns_number,
    });
  };

  const renderCamTableCell = (colKey, data) => {
    if (colKey === "camid" && data.org_entity_id == null) {
      return (
        <Text>
          <V3Link
            isQuiet
            onPress={() => handleOpenDialog(data, "standardized")}
          >
            {data[colKey]}
          </V3Link>
        </Text>
      );
    }

    if (colKey === "org_entity_id" && data.camid == null) {
      return (
        <Text>
          <V3Link isQuiet onPress={() => handleOpenDialog(data, "org")}>
            {data[colKey]}
          </V3Link>
        </Text>
      );
    }

    if (colKey === "modifieddatetime") {
      const date = new Date(data[colKey]);
      return (
        <span // eslint-disable-line jsx-a11y/no-static-element-interactions
          style={{ cursor: "text", WebkitUserSelect: "text" }}
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <Text>{date.toUTCString()}</Text>
        </span>
      );
    }

    if (colKey === "manage") {
      return (
        <TooltipTrigger>
          <ActionButton isQuiet onPress={handleManageStandardizedAccount}>
            <View>
              <Edit color="informative" />
            </View>
          </ActionButton>
          <Tooltip>Manage CAM Standardized Account</Tooltip>
        </TooltipTrigger>
      );
    }

    return (
      <span // eslint-disable-line jsx-a11y/no-static-element-interactions
        style={{ cursor: "text", WebkitUserSelect: "text" }}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Text className="prewrap">{data[colKey]}</Text>
      </span>
    );
  };

  function handleActRelPopup(data) {
    if (data.account_relationship_list) {
      setAccountRelData(data.account_relationship_list);
      setTypeOfDialog("accRelPopup");
    }
  }

  const renderSourceAccountCell = (colKey, data) => {
    if (colKey === "modifieddatetime") {
      const date = new Date(data[colKey]);
      return (
        <span // eslint-disable-line jsx-a11y/no-static-element-interactions
          style={{ cursor: "text", WebkitUserSelect: "text" }}
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <Text>{date.toUTCString()}</Text>
        </span>
      );
    }

    if (colKey === "account_id") {
      return (
        <Text>
          <V3Link
            isQuiet
            onPress={() => handleOpenDialog(data, "sourcesystem")}
          >
            {data[colKey]}
          </V3Link>
        </Text>
      );
    }

    if (colKey === "account_relationship") {
      const isRel =
        data.account_relationship_list &&
        data.account_relationship_list.length > 0;
      return (
        <>
          {isRel && (
            <ActionButton
              aria-label="Icon only"
              onPress={() => handleActRelPopup(data)}
              isQuiet
            >
              <Workflow />
            </ActionButton>
          )}
        </>
      );
    }
    return (
      <span // eslint-disable-line jsx-a11y/no-static-element-interactions
        style={{ cursor: "text", WebkitUserSelect: "text" }}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Text className="prewrap">{data[colKey]}</Text>
      </span>
    );
  };

  const renderAccountRelCell = (colKey, data) => {
    if (colKey === "modifieddatetime") {
      const date = new Date(data[colKey]);
      return <Text>{date.toUTCString()}</Text>;
    }

    return <Text className="prewrap">{data[colKey]}</Text>;
  };

  const standardizedAccountRowClicked = (camid) => {
    handleSourceAccountChange(camid);
  };

  return (
    <View marginTop="1rem" margin="size-300">
      <LoadingDialog isOpen={isPageLoading} />
      <Flex gap="size-150" wrap>
        <Picker
          width="200px"
          label="Choose type of ID"
          items={options}
          selectedKey={filters.typeOfAccount}
          onSelectionChange={(selected) => {
            setFilters((prev) => ({ ...prev, typeOfAccount: selected }));
          }}
        >
          {(item) => <Item key={item.id}>{item.name}</Item>}
        </Picker>
        <SearchField
          value={filters.id}
          onChange={(value) => {
            setFilters((prev) => ({ ...prev, id: value }));
          }}
          label="Search by id"
          onSubmit={getData}
          width="300px"
        />
      </Flex>
      {standardisedAccounts && (
        <View>
          <Flex
            marginTop="size-700"
            UNSAFE_className="stepper-box"
            UNSAFE_style={{
              backgroundColor: "white",
              borderRadius: "0.5rem",
            }}
            height={
              standardisedAccounts?.length > 0
                ? "fit-content"
                : "static-size-4600"
            }
          >
            <Table
              columns={
                isORGLookup
                  ? orgEntityAccountsColumn
                  : standardizedAccountsColumn
              }
              rows={standardisedAccounts}
              renderCell={renderCamTableCell}
              selectionMode="none"
              density="compact"
              onAction={
                !isORGLookup ? standardizedAccountRowClicked : () => <></>
              }
            />
          </Flex>
          {sourceSystemAccounts.length > 0 && (
            <View>
              <Divider size="M" marginTop="size-600" />
              {sourceSystemAccounts.length > 0 && (
                <Header id="asa" marginTop="10px">
                  {`Source Accounts For ${
                    isORGLookup ? `ORG` : `CAM`
                  } ID: ${camidSelected} (${
                    sourceSystemAccounts.length
                  } total)`}
                </Header>
              )}
              {sourceSystemAccounts.length > 0 && (
                <>
                  <Flex
                    marginTop="size-300"
                    UNSAFE_className="stepper-box"
                    UNSAFE_style={{
                      backgroundColor: "white",
                      borderRadius: "0.5rem",
                    }}
                    height={
                      sourceSystemAccounts?.length < 4 ? "fit-content" : "360px"
                    }
                  >
                    <Table
                      id="accountrelTable"
                      columns={
                        isORGLookup
                          ? orgEntitySourceSystemAccountsColumn
                          : sourceSystemAccountsColumn
                      }
                      rows={sourceSystemAccounts}
                      renderCell={renderSourceAccountCell}
                      selectionMode="none"
                      density="compact"
                      overflowMode={isORGLookup ? "truncate" : "wrap"}
                    />
                  </Flex>
                  <DialogContainer onDismiss={() => setTypeOfDialog("")}>
                    {typeOfDialog === "accRelPopup" && (
                      <AccountRelDialog
                        accountRelationshipColumn={accountRelationshipColumn}
                        accountRelData={accountRelData}
                        renderAccountRelCell={renderAccountRelCell}
                      />
                    )}
                  </DialogContainer>
                </>
              )}
            </View>
          )}
        </View>
      )}
      {openDialog && (
        <CamSlidingPane
          isPaneOpenFlag={openDialog}
          handleOpenDialog={() => setOpenDialog(false)}
          paneTitle={slidingPaneData.account_name}
          Component={
            <AccountMappingForm
              data={slidingPaneData}
              labels={slidingPaneLabels}
            />
          }
        />
      )}
    </View>
  );
}
